/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, August 22nd 2022, 9:09:33 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { ICondition, CONDITION_OPERATORS } from "lib/schemas";

interface ConditionOperatorProps {
  condition_operator: ICondition["condition_operator"];
  onChangeConditionOperator: (conditionValue: ICondition["condition_operator"]) => void;
  label?: string;
}

export const ConditionOperator = ({
  condition_operator,
  label = "Choose Operator",
  onChangeConditionOperator,
}: ConditionOperatorProps) => {
  const labelId = "condition-operator-label";
  return (
    <FormControl fullWidth>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        labelId={labelId}
        id="condition-operator"
        label={label}
        defaultValue={condition_operator}
        onChange={(e) => onChangeConditionOperator(e.target.value as ICondition["condition_operator"])}
      >
        {Object.keys(CONDITION_OPERATORS).map((conditionOperatorKey) => (
          <MenuItem value={conditionOperatorKey} key={conditionOperatorKey}>
            {CONDITION_OPERATORS[conditionOperatorKey]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
